import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionCards, { CardProps } from "#root/components/ActionCards";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import InfiniteDropdown from "#root/components/InfiniteDropdown";
import { UseInfiniteQueryResult, InfiniteData } from "@tanstack/react-query";
import { useInfiniteIncidents, useIncidentById, Incident } from "#root/queries/incidents";
import { DataCollectionApiResponse } from "#root/queries/types";
import { useCurrentTenant, useVAdminSelectedIncident  } from "#root/queries/local";
import { QRCodeDialog } from "#root/components/QRCodeDialog";
import { showToast } from "#root/components/GlobalToaster";
import { ROUTES } from "#root/routes/constants";  
import "./styles.scss";
const INCIDENTS_PER_PAGE = 10;

const FamilyAssistance: React.FC = () => {
  const navigate = useNavigate();
  const { selectedIncidentId, setVAdminSelectedIncidentId } = useVAdminSelectedIncident ();
  const [filter, setFilter] = useState<string>("");
  const [isQRDialogOpen, setIsQRDialogOpen] = useState(false);
  const { data: tenantId } = useCurrentTenant();

  const handleIncidentChange = (value: string) => {
    setVAdminSelectedIncidentId(value);
  };

  const incidentsQuery = useInfiniteIncidents({
    take: INCIDENTS_PER_PAGE,
    name: filter,
  }) as unknown as UseInfiniteQueryResult<InfiniteData<DataCollectionApiResponse<Incident>, unknown>, unknown>;


const { data: incidentForQR } = useIncidentById({ id: selectedIncidentId || "" });  

  const cards: CardProps[] = [
    {
      image: "family-assistance-requests",
      title: "Family Assistance Requests",
      onClick: () => {
        navigate(ROUTES.VADMIN.FAMILY_ASSISTANCE_ENTRIES);
      }
    },

    {
      image: "share-qr-code",
      title: "Share QR Code",
      onClick: () => {
        if (selectedIncidentId) {
          setIsQRDialogOpen(true);
        } else {
          showToast("Please select an incident first", "warning");
        }
      }
    }
  ];

  return (
    <div className="family-assistance-page">
      <div className="emc-page-header">
        <div className="emc-page-header__top-row">
          <div className="emc-page-header__breadcrumbs">
            <Breadcrumbs />
          </div>
        </div>
        <div className="incident-dropdown-wrapper">
          <h3>
            Select the Incident <div className="divider" />
          </h3>
          <div className="incident-dropdown">
            <InfiniteDropdown
              value={selectedIncidentId || ""}
              onChange={(_, data) => handleIncidentChange(data.value)}
              onFilterChange={setFilter}
              queryResult={incidentsQuery}
              itemToOption={(incident: Incident) => ({
                value: incident.id ?? "",
                text: incident.name ?? ""
              })}
              placeholder="Select incident"
            />
          </div>
        </div>
      </div>
      <div className="page-content">
        <ActionCards cards={cards} />
      </div>
      <QRCodeDialog
        incident={incidentForQR?.item || null}
        open={isQRDialogOpen}
        onOpenChange={setIsQRDialogOpen}
        qrUrl={`${window.location.origin}${ROUTES.FAMILY_ASSISTANCE_ENTRY}?tenantId=${tenantId}&incidentId=${incidentForQR?.item?.id}`}
      />
    </div>
  );
};

export default FamilyAssistance;
